import { useEffect, useRef, useState, forwardRef } from "react";
import React from "react";

const VENDOR_ID = "2355";
const WIDGET_URL = "https://widget.dinesurf.com/widget.js";
const WIDGET_SCRIPT_ID = "dinesurf-widget-script";
const WIDGET_CONTAINER_ID = "dinesurf-reservation-widget";

const WithClientOnly = ({ Component, ...rest }) => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    return mounted ? <Component {...rest} /> : null;
};

export const ClientOnlyHOC = (Component) => {
    const Wrapped = forwardRef((props, ref) => (
        <WithClientOnly Component={Component} {...props} forwardedRef={ref} />
    ));
    Wrapped.displayName = `ClientOnly(${Component.displayName || Component.name})`;
    return Wrapped;
};

const ReservationWidget = forwardRef(function ReservationWidget(_props, _ref) {
    const [widgetMounted, setWidgetMounted] = useState(false);
    const initGuard = useRef(false);

    useEffect(() => {
        if (initGuard.current) return;
        initGuard.current = true;

        const ensureScript = () => {
            let script = document.getElementById(WIDGET_SCRIPT_ID);

            const addFresh = () => {
                if (script && script.parentNode) script.parentNode.removeChild(script);

                script = document.createElement("script");
                script.id = WIDGET_SCRIPT_ID;
                script.async = true;
                script.defer = true;

                script.src = `${WIDGET_URL}?v=${Date.now()}`;

                script.setAttribute("data-mount", `#${WIDGET_CONTAINER_ID}`);
                script.setAttribute("data-key", VENDOR_ID);
                script.setAttribute("data-ordering", "false");
                script.setAttribute("data-actions", "cancel,modify");

                document.body.appendChild(script);
            };

            if (!script) {
                addFresh();
            } else {
                script.setAttribute("data-mount", `#${WIDGET_CONTAINER_ID}`);
                script.setAttribute("data-key", VENDOR_ID);
                script.setAttribute("data-ordering", "false");
                script.setAttribute("data-actions", "cancel,modify");
                if (typeof window !== "undefined" && window.initDinesurfWidget) {
                    try { window.initDinesurfWidget(); } catch { }
                } else {
                    addFresh();
                }
            }
        };

        ensureScript();

        const onMounted = () => setWidgetMounted(true);
        window.addEventListener("dinesurf:widget:mounted", onMounted);

        return () => {
            window.removeEventListener("dinesurf:widget:mounted", onMounted);
        };
    }, []);

    return (
        <div>
            <div id={WIDGET_CONTAINER_ID} style={{ minHeight: 320 }}>
                {!widgetMounted && (
                    <div className="flex justify-center items-center p-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
                    </div>
                )}
            </div>
        </div>
    );
});

ReservationWidget.displayName = "ReservationWidget";
export default ClientOnlyHOC(ReservationWidget);